import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

export const WorkbookDownstreamOwnersQueryGql: DocumentNode = gql`
query WorkbookDownstreamOwnersQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  workbooks(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
